"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGlobalNavRedirect = void 0;
var router_1 = require("next/router");
var state_1 = require("../state");
var useGlobalNavUrl_hook_1 = require("./useGlobalNavUrl.hook");
var useGlobalNavRedirect = function (protectedRoutes) {
    var router = (0, router_1.useRouter)();
    var globalNav = (0, state_1.useGlobalNav)();
    var _a = (0, useGlobalNavUrl_hook_1.useGlobalNavUrl)(), appendCurricula = _a.appendCurricula, BASE_PATH = _a.BASE_PATH;
    var isProtected = protectedRoutes.includes(router.pathname);
    var redirectTo = function (app) { return ({
        outside: function () {
            var fullUrl = window.origin + app.redirectionUrl;
            return window.location.assign(fullUrl);
        },
        inside: function () {
            if (isProtected) {
                appendCurricula(app === null || app === void 0 ? void 0 : app.id);
                return;
            }
            router.push({
                pathname: '/',
                query: { curriculaCode: app === null || app === void 0 ? void 0 : app.id },
            });
        },
        nowhere: function () {
            appendCurricula(app === null || app === void 0 ? void 0 : app.id);
            setTimeout(function () {
                var _a;
                appendCurricula((_a = globalNav.selected) === null || _a === void 0 ? void 0 : _a.id);
            }, 500);
        },
    }); };
    var shouldRedirectTo = {
        outside: function (app) { return !app.redirectionUrl.startsWith(BASE_PATH); },
        inside: function (app) { return app.redirectionUrl.startsWith(BASE_PATH); },
    };
    var redirect = function (app) {
        var _a = redirectTo(app), inside = _a.inside, nowhere = _a.nowhere, outside = _a.outside;
        if (!app.redirectionUrl)
            return inside();
        if (shouldRedirectTo.outside(app))
            return outside();
        if (shouldRedirectTo.inside(app))
            return inside();
        return nowhere();
    };
    return { redirect: redirect };
};
exports.useGlobalNavRedirect = useGlobalNavRedirect;
